// extracted by mini-css-extract-plugin
export var contrastLow = "_3o-1";
export var externalLink = "_3o-2";
export var externalLinkIcon = "_3o-3";
export var link = "_3o-0";
export var linkLabel = "_3o-4";